export default __webpack_public_path__ + "media/images/svg/icon_logo_white-ce29d7875a902d9add245ba18a3d1eb3.svg";